import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { MakePaymentService } from '../make-payment.service';
import { ManageCardsService } from '../../manage-cards/manage-cards.service';
import { FormsModule, ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { LoggerService } from '../../../logger/logger.service';
import { pid } from 'process';
import * as moment from 'moment'
import {ViewPaymentMethodsComponent} from '../../paymentus/view-payment-methods/view-payment-methods.component';

// tslint:disable-next-line:max-line-length
// const CARD_REGEX = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
const CARD_REGEX = /^4[0-9]{3}\-[0-9]{4}\-[0-9]{4}\-[0-9]{1}(?:[0-9]{3})?$|^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$|^3[47][0-9]{2}\-[0-9]{6}\-[0-9]{5}$|^6(?:011|5[0-9]{2})\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const CVV_REGEX = /^[0-9]{3,4}$/;
const EXPIRATIONDATE_REGEX = /^(0[1-9]|1[0-2])\/[0-9]{2}$/;

@Component({
  selector: 'app-pay-credit-debit',
  templateUrl: './pay-credit-debit.component.html',
  styleUrls: ['./pay-credit-debit.component.css']
})
export class PayCreditDebitComponent implements OnInit {
  public cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public expMask = [/\d/, /\d/, '\/', /\d/, /\d/];

  cardFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CARD_REGEX)]);

  expirationDateFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(EXPIRATIONDATE_REGEX)]);

  ccvFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CVV_REGEX)]);

  billingZipCodeFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(ZIPCODE_REGEX)]);

  public card_details: Array<any>;
  public card_detail: Object;
  public credit_debit_number;
  private card_number;
  public expiration_date;
  public ccv;
  public billing_zip_code;
  public add_money_valid;
  public visa_valid: boolean; // 4.
  public master_valid: boolean; // 51 through 55.
  public american_express_valid: boolean; // 37
  public discover_valid: boolean; // 6011 or 65.
  public amount: number;
  public final_amount: number;
  public threshold_amount: number;
  public processing_charges: number;
  public card_ending_digit: string;
  public cardNumber:String;
  public username: string;
  public mobile_phone: string;
  public email: string;
  public account_number: string;
  public is_verify: boolean;
  public pay_text: string;
  public is_card_detail: boolean;
  public is_payment: boolean;
  public confirmation_number: string;
  public service_balance: string;
  public is_process_payment: boolean;
  public is_express_pay: boolean;
  public card_max_length: number;
  public is_save_card: boolean;
  public show_process_charge_note: boolean;
  public card_type: string;
  public card_name: string;
  public is_primary_card: boolean;
  public primary_card: string;
  public is_new_card: boolean;
  public is_loader: boolean;
  public is_less_than_threshold: boolean;
  public img: string;
  public usedExpressPay: boolean;
  public is_transaction_error: boolean;
  public person: any;
  public ip_Address: string;

  private first_recharge_min_amount: number;
  public track_payment: boolean;
  public is_billingZip_error: boolean;
  public validateCard_error: string;
  public zipCode_valid:boolean;
  public update_button:string;
  public card_digits:string;
  public currentCardBeingEdited = undefined;
  public newExpirationDate = undefined;
  public isEditingCard = false;
  public primary_card_component: any;
  public is_transaction_retry: boolean;
  public retries: number;
  public pay_text_retry: string;
  public is_readonly_retry:boolean;

  constructor(private sharedService: SharedService, private router: Router, private localStorageService: LocalStorageService,
              private activatedRoute: ActivatedRoute, private makePaymentService: MakePaymentService,
              public dialog: MatDialog, private manageCardsService: ManageCardsService, private logger: LoggerService) {
    this.sharedService.setHeaderTitle('default_page');
    const that = this.sharedService;
    setTimeout(function () {
      that.setHeaderErrorMessage('pay_credit_debit', false, 'notification error', '');
      that.setHeaderErrorMessage('verify_payment', false, 'notification error', '');
    }, 10);
    this.add_money_valid = false;
    this.visa_valid = false;
    this.master_valid = false;
    this.american_express_valid = false;
    this.discover_valid = false;
    this.is_card_detail = false;
    this.is_verify = false;
    this.is_payment = false;
    this.pay_text = 'Recharge';
    this.confirmation_number = '';
    this.service_balance = '';
    this.is_process_payment = false;
    this.is_save_card = false;
    this.card_type = 'Credit Card';
    this.card_name = '';
    this.is_new_card = false;
    this.is_loader = false;
    this.threshold_amount = 0;
    this.processing_charges = 0;
    this.is_less_than_threshold = false;
    this.first_recharge_min_amount = 60;
    this.track_payment = false;
    this.show_process_charge_note = false;
    this.is_transaction_error = false;
    this.zipCode_valid = false;
    this.update_button= "Update";
    this.is_transaction_retry = false;
    this.retries = 0;
    this.pay_text_retry = 'Retry';
    this.is_readonly_retry = false;

    this.sharedService.getIpAddress()
      .then(res => {
        if (res.ip  !== undefined) {
          this.ip_Address = res.ip
        }
      });

    this.sharedService.getConfigConst()
      .then(res => {
        if (res.status == 'success') {
          this.threshold_amount = res.results[0]['thresholdAmount'];
          this.processing_charges = res.results[0]['processingCharge'];
          this.first_recharge_min_amount = res.results[0]['firstRechargeMinAmount'];
          this.final_amount = this.amount = Number(this.amount);
          this.is_less_than_threshold = this.amount < this.threshold_amount;
        }
      });

    if (this.localStorageService.get('token') != null) {
      this.activatedRoute.params.subscribe((params: Params) => {
        this.amount = params['amount'];
        if (params['new-card'] !== undefined) {
          if (params['new-card'] === 'new-card') {
            this.is_new_card = true;
          }
        }
      });
      let methodName = this.constructor.name + '.verifyToken';
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          if (res.status === 'success' && res.isTerminated === false) {
            this.person = res.results[0]['personal'][0];
            this.username = this.person['username'];
            this.mobile_phone = this.person['mobilePhoneNumber'];
            this.email = this.person['email'];
            this.account_number = this.person['accountNumber'];
            if (this.person['accountStatusName'] == 'Enrollment' && this.person['balance'] < this.first_recharge_min_amount) {
              this.track_payment = true;
            }
            if (this.is_less_than_threshold && !this.track_payment) {
              this.final_amount = this.amount + this.processing_charges;
              this.show_process_charge_note = true;
            }
            const that1 = this;

            that1.sharedService.setHeaderUserLoggedIn('pay_credit_debit', true, this.person);

            if (!(this.person['billingAccountNumber'] === 0 || this.person['billingAccountNumber'] == null || this.person['payAcbillingAccountNumbercId'] === '') && !this.is_new_card) {
              this.is_loader = true;
              this.makePaymentService.fetchPaymentProfiles(this.localStorageService.get('token')).then(res1 => {
                if (res1) {
                  this.is_loader = false;
                  this.is_card_detail = false;
                  this.is_verify = true;
                  this.is_payment = false;
                  this.is_primary_card = true;
                  this.card_details = res1.result;
                  var pId: any;
                /*  for (let i in res1.result) {
                    if (res1.result[i].defaultPaymentProfile) {
                      pId = i;
                      break;
                    }
                  }*/

                  if (pId == null || pId == undefined){
                    if (res1.length > 0){
                      pId = 0
                    }
                  }

                  if (pId != undefined && pId != null) {
                    this.primary_card = '' + res1[pId].paymentProfileId;
                    this.card_ending_digit = '' + res1[pId].cardNo;
                    this.cardNumber  = res1[pId].cardNo;
                    this.card_ending_digit = this.card_ending_digit.substring(this.card_ending_digit.length - 4);
                    this.card_name = res1[pId].cardType;
                    this.newExpirationDate = moment(this.card_details[0].expiryDate).format('MM/YY');
                    this.expiration_date = this.card_details[0].expiryDate;
                  }
                  else{
                    var newRoute = router.url.trim()+'/new-card';
                    router.navigate([newRoute])
                  }

                  const data = {
                    'token': this.localStorageService.get('token'),
                    'payAccId': this.primary_card
                  }
                  this.is_process_payment = true;
                  this.is_billingZip_error = false;
                  this.manageCardsService.validateCard(data).then(res => {
                    if (res.messages.resultCode === 1) {  //If the response is 1 so we need to enable BillingZipCode to add in the creditCard
                      this.validateCard_error = res.messages.message[0].text;
                      this.is_billingZip_error = true;
                      this.isEditingCard = true;
                    }
                    else
                      this.is_process_payment = true;
                  });
                }

              });
              setTimeout(function () {
                that1.sharedService.setHeaderTitle('verify_payment');
              }, 10);
            } else {
              this.is_card_detail = true;

              that1.sharedService.setHeaderTitleDynamicVal('pay_credit_debit', '' + that1.final_amount,
                'to account ' + this.person['accountNumber']);

            }
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', 'make-payment');
            this.router.navigate(['./sign-in']);
          }
        }, (error) => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: "token : [masked]",
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
    } else {
      this.is_card_detail = true;
      this.activatedRoute.params.subscribe((params: Params) => {
        this.amount = params['amount'];
        if (this.localStorageService.get('mobile_phone') != null) {
          this.mobile_phone = this.localStorageService.get('mobile_phone');
          this.account_number = this.localStorageService.get('account_number');
          const context = this;
          this.usedExpressPay = true;
          this.makePaymentService.barcodeImage({ 'accountNumber': '' + this.localStorageService.get('account_number') })
            .then(res => {
              // if (res.account['account_status_name'] == 'Enrollment' && res.account['balance'] < this.first_recharge_min_amount) {
              //   this.track_payment = true;
              // }
              if (this.is_less_than_threshold && !this.track_payment) {
                this.final_amount = this.amount + this.processing_charges;
                this.show_process_charge_note = true;
              }
              setTimeout(function () {
                context.sharedService.setHeaderTitleDynamicVal('pay_credit_debit', '' + context.final_amount, 'to account ' + context.account_number);
                context.sharedService.setHeaderTitleCancelUrl('pay_credit_debit', undefined);
              }, 10);
            });
          this.is_express_pay = true;
          this.is_save_card = false;
        } else if (this.localStorageService.get('email') != null) {
          this.email = this.localStorageService.get('email');
          const context = this;
          this.usedExpressPay = true;
          this.makePaymentService.barcodeImage({ 'accountNumber': '' + this.localStorageService.get('account_number') })
            .then(res => {
              // if (res.account['account_status_name'] == 'Enrollment' && res.account['balance'] < this.first_recharge_min_amount) {
              //   this.track_payment = true;
              // }
              if (this.is_less_than_threshold && !this.track_payment) {
                this.final_amount = this.amount + this.processing_charges;
                this.show_process_charge_note = true;
              }
              setTimeout(function () {
                context.sharedService.setHeaderTitleDynamicVal('pay_credit_debit', '' + context.final_amount, 'to account ' + context.email);
                context.sharedService.setHeaderTitleCancelUrl('pay_credit_debit', undefined);
              }, 10);
            });
          this.is_express_pay = true;
          this.is_save_card = false;
        } else {
          this.localStorageService.set('returnUrl', 'make-payment');
          this.router.navigate(['./sign-in']);
        }
      });
    }
  }

  unmaskData(data: string) {
    if (data != null && data.trim() != "") {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return "";
    }
  }

  addMoneyValidate(credit_card: any) {
    // if (this.expiration_date !== undefined && this.expiration_date !== '') {
    //   // tslint:disable-next-line:prefer-const
    //   let parts = this.expiration_date.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/),
    //     mon,
    //     sep,
    //     year;
    //   if (!parts) {
    //     return '';
    //   }
    //   mon = parts[1] || '';
    //   sep = parts[2] || '';
    //   year = parts[3] || '';
    //   if (credit_card.keyCode !== 8) {
    //     if (year.length > 0) {
    //       sep = '/';
    //     } else if (sep === '/') {
    //       mon = mon.substring(0, 1);
    //       sep = '';
    //     } else if (mon.length === 2 || sep.length > 0) {
    //       sep = '/';
    //     } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
    //       mon = `0${mon}`;
    //       sep = '/';
    //     }
    //     this.expiration_date = `${mon}${sep}${year}`;
    //   } else {
    //     if (this.expiration_date.length === 2) {
    //       this.expiration_date = this.expiration_date[0];
    //     }
    //   }
    //   if (this.expiration_date.length === 6) {
    //     let temp = '';
    //     for (let i = 0; i < 5; i++) {
    //       temp += this.expiration_date[i]
    //     }
    //     this.expiration_date = temp;
    //   }
    // }
    if (this.credit_debit_number !== undefined) {
      this.card_number = this.unmaskData(this.credit_debit_number);
      if (this.card_number.match(/^4/)) {
        this.visa_valid = true;
        this.card_name = 'Visa';
        this.american_express_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/visa.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^(5[1-5]|2[2-7])/)) {
        this.master_valid = true;
        this.card_name = 'MasterCard';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
        this.img = 'assets/images/masterCard.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^3[47]/)) {
        this.american_express_valid = true;
        this.card_name = 'American Express';
        this.visa_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/americanExpress.png';
        this.card_max_length = 17;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.card_number.match(/^6([045]|22)/)) {
        this.discover_valid = true;
        this.card_name = 'Discover';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/discover.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else {
        this.visa_valid = false;
        this.master_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
        this.card_name = '';
      }
    }
    if (this.billing_zip_code !== '' && this.billing_zip_code !== undefined  && this.billing_zip_code.match(ZIPCODE_REGEX) && this.is_process_payment === true)
    {
      this.zipCode_valid = false;
      this.validateCard_error = null;
      if (this.billing_zip_code !== '' && this.billing_zip_code !== undefined  && this.billing_zip_code.match(ZIPCODE_REGEX))
      {
        this.zipCode_valid = true;
      }
    }

    if (this.card_number !== '' && this.expiration_date !== '' && this.ccv !== '' &&
      this.billing_zip_code !== '' && this.card_number !== undefined && this.expiration_date !== undefined &&
      this.ccv !== undefined && this.billing_zip_code !== undefined && this.card_number.length > 12 &&
      this.ccv.length > 2 && this.ccv.match(CVV_REGEX) && this.billing_zip_code.match(ZIPCODE_REGEX) &&
      this.credit_debit_number.match(CARD_REGEX) && this.expiration_date.match(EXPIRATIONDATE_REGEX)) {
      this.add_money_valid = true;
      if (credit_card.keyCode === 13) {
        document.getElementById('next_pay').click();
      }
    } else {
      this.add_money_valid = false;
    }

    if (this.ccv !== '' && this.ccv !== undefined && this.ccv.length > 2 && this.ccv.match(CVV_REGEX)) {
      this.is_process_payment = false;
      if (credit_card.keyCode === 13) {
        document.getElementById('next_pay').click();
      }
    } else {
      /*if (this.ccv=='')
      {
        this.sharedService.setHeaderTitle('verify_payment');
        this.is_transaction_error = false;
      }*/
      this.add_money_valid = false;
      this.is_process_payment = true;
    }

  }

  addMoney() {
    this.sharedService.setHeaderErrorMessage('pay_credit_debit', false, 'notification error', '');
    if (this.card_name !== '') {
      this.sharedService.setHeaderErrorMessage('verify_payment', false, 'notification error', '');
      let card_digit_groups = this.credit_debit_number.split('-');
      this.card_ending_digit = card_digit_groups[card_digit_groups.length - 1];
      const localEmail = this.localStorageService.get('email')
      this.card_detail = {
        'CardNumber': this.card_number,
        'ExpireMonth': this.expiration_date,
        'CCV': this.ccv,
        'CardZipCode': this.billing_zip_code,
        'PaymentAmount': String(this.amount),
        'token': this.localStorageService.get('token'),
        'save_card': this.is_save_card,
        'cardName': this.card_name,
        'cardType': this.card_type,
        'mobilePhoneNumber': this.mobile_phone,
        'email': localEmail ? this.localStorageService.get('email') : this.email
      }

      this.is_card_detail = false;
      this.is_verify = true;
      this.is_payment = false;
      const that = this.sharedService;
      setTimeout(function () {
        that.setHeaderTitle('verify_payment');
        that.setHeaderTitleCancelUrl('verify_payment', undefined);
      }, 10);
    } else {
      window.scrollTo(0, 0);
      this.sharedService.setHeaderErrorMessage('pay_credit_debit', true, 'notification error', 'Invalid Card');
    }
  }

  cancelCardUpdate() {
    this.isEditingCard = false;
    this.openCardList();
  }

  updateCreditCard() {
    this.zipCode_valid = false;
    this.update_button= "Updating...";

    this.card_detail = {
      'CardNumber': this.card_ending_digit,
      PaymentProfileId: this.primary_card,
      'ExpireMonthYear': this.expiration_date,
      'CCV': this.ccv,
      'CardZipCode': this.billing_zip_code,
      'token': this.localStorageService.get('token'),
      'cardName': this.card_name,
      'cardType': this.card_type
    }

    this.is_process_payment = true;

    this.manageCardsService.updateCard(this.card_detail).then(res => {
      if (res.status === 'fail') {
        this.validateCard_error = res.message;
        this.is_billingZip_error = true;
        this.zipCode_valid = false;
        this.update_button = 'Update';
        this.billing_zip_code = '';
      } else {
        this.isEditingCard = false;
        this.is_billingZip_error = false;
      }
    });
  }

  verifyPay() {
    this.sharedService.setHeaderErrorMessage('pay_credit_debit', false, 'notification error', '');
    this.sharedService.setHeaderErrorMessage('verify_payment', false, 'notification error', '');
    this.pay_text = 'Processing...';
    this.pay_text_retry = 'Processing...';
    this.is_process_payment = true;
    this.is_readonly_retry = true;

    let payment_obj;
    if (this.is_primary_card) {
      payment_obj = {
        'token': this.localStorageService.get('token'),
        'PaymentAmount': String(this.amount),
        'pay_acc_id': this.primary_card,
        'accountNumber': this.account_number,
        'cardEndingDigits': this.card_ending_digit
      };
    } else {
      payment_obj = this.card_detail;
    }

    payment_obj.CCV = this.ccv;
    payment_obj.cardEndingDigits = this.card_ending_digit;
    payment_obj.IPAddress = this.ip_Address;

    if (this.retries==0)
    {
      payment_obj.isRetry = false;
    }
    else
    {
      payment_obj.isRetry = true;
      payment_obj.ExpireMonth = this.expiration_date;
      if (payment_obj.pay_acc_id == null)
        payment_obj.CardNumber = this.card_number;
      payment_obj.CardZipCode =  this.billing_zip_code;
    }

    let methodName = this.constructor.name + '.paymentPay';
    this.makePaymentService.paymentPay(payment_obj).then(res => {
      if (payment_obj.hasOwnProperty('CardNumber')) {
        payment_obj['CardNumber'] = "[masked]-" + payment_obj['CardNumber'].substr(payment_obj['CardNumber'].length - 4);
        payment_obj['ExpireMonth'] = "[masked]";
        payment_obj['CCV'] = "[masked]";
        payment_obj['CardZipCode'] = "[masked]";
      }

      let logObj = {
        method: methodName,
        request: payment_obj,
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));
      if (res.result.status === 'success') {
        const that = this.sharedService;
        if (this.usedExpressPay) {
          this.localStorageService.set('used_mobile_no', this.mobile_phone);
          this.localStorageService.set('used_email', this.email);
        }
        setTimeout(function () {
          that.setHeaderTitle('payment_receive');
          that.setHeaderTitleCancelUrl('payment_receive', undefined);
        }, 10);
        this.confirmation_number = res.result.paymentConfirmationNumber;

        // if (this.localStorageService.get('token') != null){
        //   if (this.is_less_than_threshold && !this.track_payment) {
        //     this.service_balance = (parseFloat(this.person.balance) + this.final_amount - this.processing_charges).toString();
        //   } else {
        //     this.service_balance = (parseFloat(this.person.balance) + this.final_amount).toString();
        //   }
        // }else{
        this.service_balance = res.result.accountBalance;
        // }


        this.is_card_detail = false;
        this.is_verify = false;
        this.is_payment = true;
        this.pay_text = 'Recharge';
        this.pay_text_retry = 'Retry';
        this.is_process_payment = false;
      } else {
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('transaction_error', true, 'notification error', res.result.message);
        this.sharedService.setHeaderTitleDynamicVal('transaction_error', res.result.cardMessage, '');
        this.is_transaction_error = true;
        this.pay_text = 'Recharge';
        this.pay_text_retry = 'Retry';
        this.is_process_payment = false;
        if (this.retries==0)
        {
          this.is_transaction_retry = true;
          this.retries++;
          this.is_readonly_retry = false;
        }
        else
        {
          this.is_transaction_retry = false;
          this.is_transaction_error = true;
        }

      }
    }, (error) => {
      let logObj = {
        method: methodName,
        request: payment_obj,
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex) => {
      let logObj = {
        method: methodName,
        request: payment_obj,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }

  ngOnInit() {
  }

  openCardList() {
    if (this.is_readonly_retry == false)
    {
      this.isEditingCard = true;
      if (this.localStorageService.get('token') != null) {
        const dialogRef = this.dialog.open(ViewPaymentMethodsComponent, {
          data: { amount: String(this.amount), primary_card: this.primary_card },
          width: '100%'
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result !== undefined) {
            this.primary_card = '' + result.paymentProfileId;
            this.card_ending_digit = '' + result.card_detail;
            this.card_ending_digit = this.card_ending_digit.substring(this.card_ending_digit.length - 4);
            this.card_name = '' + result.card_name;
            this.is_primary_card = true;
          }

          const data = {
            'token': this.localStorageService.get('token'),
            'payAccId': this.primary_card
          }
          this.is_billingZip_error = false;
          this.is_process_payment = true;
          for (const card_detail of this.card_details){
            if (card_detail.paymentProfileId ===  result.paymentProfileId) {
              this.primary_card_component = card_detail;
              this.newExpirationDate = moment(this.primary_card_component.expiryDate).format('MM/YY');
              this.expiration_date = card_detail.expiryDate;
              this.card_digits = card_detail.cardNo;
              this.currentCardBeingEdited = card_detail;
            }
          }
          this.manageCardsService.validateCard(data).then(res => {
            if (res.messages.resultCode === 1) {
              this.validateCard_error = res.messages.message[0].text;
              this.is_billingZip_error = true;
              this.isEditingCard = true;
            } else {
              this.is_process_payment = true;
              this.ccv = '';
              this.isEditingCard = false;
            }
          });
        });
      } else {
        this.router.navigate(['./make-payment']);
      }
    }
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'card-list',
  templateUrl: './card-list.html'
})
// tslint:disable-next-line:component-class-suffix
export class CardList {
  public card_details: Array<object>;
  public card_name_list: Object;
  public is_savecard_loader: boolean;
  public amount_new: any;
  public primary_card: any;

  constructor(private router: Router, private localStorageService: LocalStorageService,
              private activatedRoute: ActivatedRoute, private manageCardsService: ManageCardsService, private logger: LoggerService,
              public dialogRef: MatDialogRef<CardList>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.amount_new = data.amount;
    this.primary_card = data.primary_card
    const dialogOverlay = document.getElementsByClassName('cdk-overlay-container')[0];
    dialogOverlay.classList.add('bottom-sheet');
    const dialogClass = document.getElementsByClassName('cdk-overlay-pane')[0];
    dialogClass.classList.add('bottom-sheet-container');
    if (this.localStorageService.get('token') != null) {
      this.is_savecard_loader = true;
      const methodName = this.constructor.name + '.getCards';
      this.manageCardsService.getPaymentProfiles(this.localStorageService.get('token')).then(res => {
        const logObj = {
          method: methodName,
          request: 'Token : [masked]]',
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        if (res.status === 'success') {
          this.cardTypeConvert(res.result);
          this.card_details = res.result;
          this.is_savecard_loader = false;
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "Token : [masked]]",
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: "Token : [masked]]",
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
    }
  }

  cardTypeConvert(card_types: any) {
    this.card_name_list = {};
    for (const card_type of card_types) {
      this.card_name_list[card_type.cardNo] = card_type.cardType;
    }
  }

  selectCard(paymentProfileId: any, card_detail: any, card_name: any) {
    this.dialogRef.close({ 'paymentProfileId': paymentProfileId, 'card_detail': card_detail, 'card_name': card_name });
  }

  closeCardList() {
    // this.router.navigate(['./recharge/40/new-card']);
    this.dialogRef.close();
    // setTimeout(function(){
    location.href = "./recharge/" + this.amount_new + "/new-card";
    // }, 1000);


  }
}



// WEBPACK FOOTER //
// ./src/app/payment/make-payment/pay-credit-debit/pay-credit-debit.component.ts